
  @let vState = state();
  @if (vState) {
    @if (vState.isLoading) {
      <p class="heading-md card-loading">
        Gathering dates information...
      </p>
    } @else if (vState.error) {
      <p>Failed to load dates information</p>
    } @else if (vState.data) {
      <div class="card-content">
        <a class="date-value card-link" routerLink="dates" aria-atomic="true">
          <h3 class="heading-3xs overlay-text">{{ vState.data | stageTitle }}</h3><br>
          <p class="heading-lg overlay-text">
            {{ vState.data | dateRange }}
          </p>
        </a>
        @if (isOwner()) {
          @if (vState.data.state !== 'NotStarted') {
            <a class="button sm secondary" [routerLink]="editLink()">
              <span class="md:sr-only">Edit</span>
              <div class="icon icon-xs icon-edit-2"></div>
            </a>
          } @else {
            <div class="member-actions">
              <div class="action-incomplete">
                <div class="icon icon-md icon-circle"></div>
                <p class="all-caps">Todo</p>
                <p class="body-copy-md">Start choosing dates</p>
              </div>
              <a class="button primary green" [routerLink]="editLink()">
                <span>Start</span><span class="sr-only">choosing dates</span>
                <div class="icon icon-arrow-right"></div>
              </a>
            </div>
          }
        }

        @let vStage = stage();
        @let vLocked = locked();
        @if (vStage && !vLocked && (vStage === 'GatheringAvailability' || vStage === 'GatheringRSVP')) {
          <div class="member-actions">
            @switch (vState.data.state) {
              @case ('GatheringAvailability') {
                @if (vState.data.availabilityResponse) {
                  <div class="action-complete">
                    <div class="icon icon-check"></div>
                    <p class="all-caps">All set</p>
                    <p>Availability submitted</p>
                  </div>
                } @else {
                  <div class="action-incomplete">
                    <div class="icon icon-md icon-circle"></div>
                    <p class="all-caps">Todo</p>
                    <p class="body-copy-md">Submit your availability</p>
                  </div>
                  <button class="button primary green" (click)="availabilityDialog.showModal()">
                    <span>Start</span><span class="sr-only">submitting your availability</span>
                    <div class="icon icon-arrow-right"></div>
                  </button>

                  <dialog #availabilityDialog class="modal-dialog">
                    <at-availability-picker class="dialog-content"
                      (availabilityChange)="availabilityDialog.close()">
                    </at-availability-picker>
                  </dialog>
                }
              }
              @case ('GatheringRSVP') {
                @if (vState.data.rsvpResponse) {
                  <div class="action-complete">
                    <div class="icon icon-check"></div>
                    <p class="all-caps">All set</p>
                    <p>RSVP submitted</p>
                  </div>
                } @else {
                  <div class="action-incomplete">
                    <div class="icon icon-md icon-circle"></div>
                    <p class="all-caps">Todo</p>
                    <p class="body-copy-md">Submit your RSVP</p>
                  </div>
                  <button class="button primary green" (click)="rsvpDialog.showModal()">
                    <span>RSVP</span>
                    <div class="icon icon-arrow-right"></div>
                  </button>

                  <dialog #rsvpDialog class="modal-dialog">
                    <at-rsvp
                      (replyChange)="rsvpDialog.close()"
                      [dates]="vState.data.selectedDates!"
                      [previousReply]="vState.data.rsvpResponse"></at-rsvp>
                  </dialog>
                }
              }
            }
          </div>
        } @else if (vLocked) {
          <div class="member-actions">
            <div class="action-incomplete">
              <div class="icon icon-md icon-lock"></div>
              <p class="all-caps">Locked</p>
              <p class="body-copy-md">Organizer locked dates input</p>
            </div>
          </div>
        }
      </div>
    }
  }